import * as React from 'react';
import { useState } from 'react';
import { Grid, Typography, IconButton } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import moment from 'moment';
import AssessmentIcon from '@mui/icons-material/Assessment';

interface ISingleDateChipProps {
    filterName: string,
    onSelect: (filterName: string, value: any) => void,
    title: string,
    currentSelection: Date,
    show: boolean,
    removeFilter?: (filter: string, names: string[]) => void;
    filterFlag: string;
    filterNames: string[];
    isAgent: boolean;
    showOnReport?: boolean;
}

export default function SingleDateChip(props: ISingleDateChipProps) {
    const [selectedDate, setSelectedDate] = useState<any>(moment(props.currentSelection));
    const [minDateLimit, setMinDateLimit] = useState<any>(moment());

    React.useEffect(() => {
        let minDate = moment().subtract(1, "month")
        minDate = minDate.set("date", 1);
        setMinDateLimit(minDate);
    }, [])

    React.useEffect(() => {
        setSelectedDate(moment(props.currentSelection));
    }, [props.currentSelection])

    const handleSelect = (value: any) => {
        props.onSelect(props.filterName, value);
    }
    const handleDelete = () => {
        if (props.removeFilter !== null && props.removeFilter !== undefined) {
            props.removeFilter(props.filterFlag, props.filterNames);
        }
    }

    const showRemove = props.removeFilter !== null && props.removeFilter !== undefined ?
        <IconButton title="Remove" aria-label="Remove" onClick={handleDelete} sx={{ padding: 0, margin: '4px' }}><CancelIcon /></IconButton> : <React.Fragment />;

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <>
                {props.show &&
                    <Grid>
                        <Grid container sx={{ minHeight: '32px', backgroundColor: '#e0e0e0', borderRadius: '16px', }} justifyContent="space-between" alignItems="center">
                            {props.showOnReport &&
                                <AssessmentIcon sx={{ ml: 1 }} />
                            }
                            <Grid sx={{ padding: '0 12px', }}>
                                <Typography variant="body1">{props.title}</Typography>
                            </Grid>
                            {(props.currentSelection !== null && props.currentSelection !== undefined) &&
                                props.isAgent ?
                                <DatePicker onChange={(newDate: moment.Moment | null) => handleSelect(newDate)} format={"DD/MM/YYYY"} sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '168px' }} value={selectedDate} minDate={minDateLimit} slotProps={{
                                    textField: {
                                        inputProps: { readOnly: true }
                                    }
                                }} />
                                :
                                <DatePicker onChange={(newDate: moment.Moment | null) => handleSelect(newDate)} format={"DD/MM/YYYY"} sx={{ border: 'none', "& fieldset": { border: 'none' }, maxHeight: '32px', bottom: '12px', maxWidth: '168px' }} value={selectedDate} slotProps={{
                                    textField: {
                                        inputProps: { readOnly: true }
                                    }
                                }} />
                            }
                            <Grid>
                                {showRemove}
                            </Grid>
                        </Grid>
                    </Grid>
                }
            </>
        </LocalizationProvider>
    )
}
